import { render, staticRenderFns } from "./QuestionAnswer.vue?vue&type=template&id=1238a7b2&scoped=true&"
import script from "./QuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswer.vue?vue&type=style&index=0&id=1238a7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1238a7b2",
  null
  
)

export default component.exports